<!--
    Name:			TableNumbers.vue
    Description:	Show the tablenumbers as a ruler on the right
-->

<template>
    <div class="table-number-filter">
        <!-- Scroll Up Button -->
        <button v-if="canScroll" class="scroll-button up filter-table-number" @click="scrollUp">▲</button>

        <div ref="scrollContainer" class="tablenumbers">
            <div class="filter-table-number" :class="{'on' :selectedTableNumber == tablenumber }" v-for="tablenumber in tableNumbers" v-on:click="clickTableNumber(tablenumber)">
                {{tablenumber}}
            </div>
        </div>

        <!-- Scroll Down Button -->
        <button v-if="canScroll" class="scroll-button down filter-table-number" @click="scrollDown">▼</button>
    </div>
</template>

<script>

  
    const TableNumbers = {
        data() {
            return {
                canScroll: false,
                timeout: null
            };
        },
        methods: {
            clickTableNumber: function (tablenumber) {
                this.$signalR.setTableNumber(tablenumber);
                if (this.$configRepository.tableSelectionExpiryTime && this.$configRepository.tableSelectionExpiryTime > 0) {
                    this.timeout = window.setTimeout(() => {
                        this.$signalR.setTableNumber(0);
                    }, this.$configRepository.tableSelectionExpiryTime * 1000)
                }               
            },
            scrollUp() {
                this.$refs.scrollContainer.scrollBy({ top: -50, behavior: "smooth" });
            },
            scrollDown() {
                this.$refs.scrollContainer.scrollBy({ top: 50, behavior: "smooth" });
            },
            checkScroll() {
                const el = this.$refs.scrollContainer;
                if (el) {
                    this.canScroll = el.scrollHeight > el.clientHeight;
                }
            }
        },
        computed: {
            tableNumbers: function () { return this.$signalR.tableNumbers },
            selectedTableNumber: function () { return this.$signalR.selectedTableNumber }
        },
        watch: {
            "tableNumbers": function () {
                this.$nextTick(() => {
                    this.checkScroll();
                });
            }
        },

        mounted() {
            this.$nextTick(() => {
                this.checkScroll();
                this.$refs.scrollContainer.addEventListener("scroll", this.checkScroll);
                window.addEventListener("resize", this.checkScroll); // Update on resize
            });
        },
        beforeUnmount() {
            this.$refs.scrollContainer.removeEventListener("scroll", this.checkScroll);
            window.removeEventListener("resize", this.checkScroll);
        }
    };

    export { TableNumbers as default };

</script>
